import { ReactElement } from 'react';

/**
 * AccessColorBlock component to render div with color according to access.
 * @param root0 - Properties of AccessColorBlock component.
 * @param root0.withLabel - Wheather to show access level title.
 * @param root0.accessLevel - Accesslevel of the block.
 * @returns - A Roles Tab management component.
 */
export default function AccessColorBlock({
  withLabel,
  accessLevel
}: {
  withLabel?: boolean;
  accessLevel: 'full' | 'view' | 'none';
}): ReactElement {
  /**
   * Function to get background color by access level.
   * @param access - Access level of the block.
   * @returns - Background color.
   */
  const getBackgroundColorByAccess = (access: 'full' | 'view' | 'none'): string => {
    if (access === 'full') {
      return 'bg-success-500';
    }
    if (access === 'view') {
      return 'bg-warning-500';
    }
    return 'bg-error-500';
  };

  /**
   * Function to get text color by access level.
   * @param access - Access level of the block.
   * @returns - Text color.
   */
  const getTextColorByAccess = (access: 'full' | 'view' | 'none'): string => {
    if (access === 'full') {
      return 'text-success-500';
    }
    if (access === 'view') {
      return 'text-warning-500';
    }
    return 'text-error-500';
  };

  /**
   * Function to get label by access level.
   * @param access - Access level of the block.
   * @returns - Label.
   */
  const getAccessLabel = (access: 'full' | 'view' | 'none'): string => {
    if (access === 'full') {
      return 'Full access';
    }
    if (access === 'view') {
      return 'View access';
    }
    return 'No access';
  };

  return (
    <div className="flex justify-center items-center flex-col">
      <div className={`w-10 h-5 rounded ${getBackgroundColorByAccess(accessLevel)}`} />
      {withLabel && (
        <div className={`text-xs mt-2 ${getTextColorByAccess(accessLevel)}`}>
          {getAccessLabel(accessLevel)}
        </div>
      )}
    </div>
  );
}
